// extracted by mini-css-extract-plugin
export var founderArrow = "homePortfolioCard-module--founderArrow--3gayV";
export var founder = "homePortfolioCard-module--founder--1eo1n";